import {
  accesscontroller1,
  accesscontroller2,
  accesscontroller3,
  accesscontroller4,
  accesscontrollerOutlook,
  accesscontrollerThumb,
  accessAuto1,
  accessAuto2,
  accessAuto3,
  accessAuto4,
  accessAutoOutlook,
  accessAutoThumb,
  accessKey2,
  accessKey3,
  accessKey4,
  accessKeyOutlook,
  accessKeyThumb,
  accessKeyM1,
  accessPro1,
  accessPro2,
  accessPro3,
  accessPro4,
  accessProOutlook,
  accessProThumb,
  apart1,
  apart2,
  apart3,
  apart4,
  apartThumb,
  deadbolt2,
  deadbolt3,
  deadbolt4,
  deadboltThumb,
  deadboltM1,
  emlock2,
  emlock3,
  emlock4,
  emlockThumb,
  emlockM1,
} from '@assets/images/main/access/product';

import {
  assetTag1,
  assetTag2,
  assetTag3,
  assetTag4,
  assetTagOutlook,
  orbroTag1,
  orbroTag2,
  orbroTag3,
  orbroTag4,
  orbroTagOutlook,
} from '@assets/images/main/beacon/product';
import {
  enterpriseKit1,
  enterpriseKit2,
  enterpriseKit3,
  enterpriseKitTopology,
  ipCam1,
  ipCam2,
  ipCam3,
  ipCam4,
  ipCamKey1,
  ipCamKey2,
  ipCamKey3,
  ipThumb,
  l2SwitchOutlook,
  ptzCam1,
  ptzCam2,
  ptzCam3,
  ptzCam4,
  ptzCamKey1,
  ptzCamKey2,
  ptzCamKey3,
  ptzThumb,
  starterKit1,
  starterKit2,
  starterKit3,
  starterKit4,
  starterKit5,
  starterKit6,
  starterKit7,
  starterKit8,
  starterKit9,
  starterKitOutlook,
  starterKitTopology,
} from '@assets/images/main/camera';
import {
  cobot1,
  cobot2,
  cobot3,
  deliverPackage,
  deliverRobot1,
  deliverRobot2,
  disinfection1,
  disinfection2,
  loadingKiosk1,
  loadingKiosk2,
} from '@assets/images/main/integration';
import {
  bell1,
  bell2,
  bell3,
  bell4,
  bellOutlook,
  esl1,
  esl2,
  esl3,
  esl4,
  eslOutlook,
  idCard1,
  idCard2,
  idCard3,
  idCard4,
  idCard5,
  idCard6,
  idCard7,
  idCardOutlook,
  mCradle1,
  mCradle2,
  mCradle3,
  mCradle4,
  mCradle5,
  mCradle6,
  mCradle7,
  mCradleOutlook,
  mCradleThumb,
  mTag1,
  mTag2,
  mTag2_1,
  mTag2_2,
  mTag2_3,
  mTag2_4,
  mTag2_Outlook,
  mTag2_Thumb,
  mTag2_key1,
  mTag2_key2,
  mTag2_key3,
  mTag3,
  mTag4,
  mTagOutlook,
  mTagThumb,
  switch1,
  switch2,
  switch3,
  switch4,
  switchOutlook,
} from '@assets/images/main/iot/product';
import { osServer1, osServer2, osServer3 } from '@assets/images/main/os/product';
import {
  vehicleTrackingKit1,
  vehicleTrackingKit2,
  vehicleTrackingKit3,
  vehicleTrackingKitThumb,
  yardTrackingKit1,
  yardTrackingKit2,
  yardTrackingKit3,
  yardTrackingKitThumb,
} from '@assets/images/main/outdoor';
import {
  aoaOutlook,
  coinTagOutlook,
  edgeRtlsOutlook,
  gpsOutlook,
  l2switchOutlook,
  orbroAoaTagOutlook,
  plutoconProOutlook,
  slimtagOutlook,
  stickerTagOutlook,
  twintrackerBleOutlook,
  uwbTagOutlook,
} from '@assets/images/main/outlook';
import {
  aoaEnterpriseKit,
  aoaEnterpriseKitThumb,
  aoaStarterKit,
  aoaStarterKitThumb,
  assetTagBleOutlook,
  assetTracking1,
  assetTracking2,
  assetTracking3,
  assetTracking4,
  bleEnterpriseKit,
  bleStarterKit2,
  comfortKit1,
  comfortKit2,
  comfortKitThumb,
  edgeRtls1,
  serverPc,
  tagUwb1,
  tagUwb2,
  tagUwbOutlook,
  twinTracker1,
  twinTracker2,
  twinTracker3,
  twinTracker4,
  twinTracker5,
  twinTracker6,
  twintracker7,
  twinTrackerAoa1,
  twinTrackerAoa2,
  twinTrackerAoa3,
  twinTrackerAoaThumb,
  twinTrackerBracket,
  twinTrackerOutlook,
  uwbEnterpriseKit,
  uwbEnterpriseKitThumb,
  uwbStarterKit,
  uwbStarterKitThumb,
  uwbTag1,
  uwbTag2,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import {
  airQuality1,
  airQuality2,
  airQuality3,
  airQuality4,
  coMeasure1,
  coMeasure2,
  coMeasure3,
  coMeasure4,
  loraGateway1,
  loraGateway2,
  loraGateway3,
  loraGateway4,
  loraSensor1,
  loraSensor2,
  loraSensor3,
  loraSensor4,
} from '@assets/images/main/sensor';
import { eslThumbnail, safetyBellThumbnail, switchThumbnail, twinTrackerThumbnail } from '@assets/images/main/thumbnail';
import {
  aoaEnterpriseTopology,
  aoaStarterTopology,
  bleEnterpriseTopology,
  bleStarterTopology,
  osAiTopology,
  osRtlsTopology,
  osServerTopology,
  osSwitchTopology,
  twintrackerUwbTopology,
  uwbEnterpriseTopology,
  uwbStarterTopology,
} from '@assets/images/main/topology';

export default {
  product: {
    accesscontroller: {
      thumbnail: accesscontrollerThumb,

      mini1: accesscontroller1,
      mini2: accesscontroller2,
      mini3: accesscontroller3,
      mini4: accesscontroller4,

      key1: accesscontroller1,
      key2: accesscontroller2,
      key3: accesscontroller3,
      outlook: accesscontrollerOutlook,
    },

    accessauto: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: accessAutoOutlook,
    },

    apart: {
      thumbnail: apartThumb,

      mini1: apart1,
      mini2: apart2,
      mini3: apart3,
      mini4: apart4,

      key1: apart2,
      key2: apart4,
      key3: apart3,
      key4: accessAuto1,

      outlook: accessAutoOutlook,
    },

    cloud: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: accessAutoOutlook,
    },

    accesspro: {
      thumbnail: accessProThumb,

      mini1: accessPro1,
      mini2: accessPro2,
      mini3: accessPro3,
      mini4: accessPro4,

      key1: accessPro1,
      key2: accessPro2,
      key3: accessPro4,

      outlook: accessProOutlook,
    },

    accesskey: {
      thumbnail: accessKeyThumb,

      mini1: accessKeyM1,
      mini2: accessKey2,
      mini3: accessKey3,
      mini4: accessKey4,

      key1: accessKeyM1,
      key2: accessKey2,
      key3: accessKey3,

      outlook: accessKeyOutlook,
    },

    emlock: {
      thumbnail: emlockThumb,

      mini1: emlockM1,
      mini2: emlock2,
      mini3: emlock3,
      mini4: emlock4,

      key1: emlockM1,
      key2: emlock2,
      key3: emlock3,

      outlook: '',
    },

    deadbolt: {
      thumbnail: deadboltThumb,

      mini1: deadboltM1,
      mini2: deadbolt2,
      mini3: deadbolt3,
      mini4: deadbolt4,

      key1: deadboltM1,
      key2: deadbolt2,
      key3: deadbolt3,

      outlook: '',
    },

    autoDoorSensor: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: accessAutoOutlook,
    },

    twinTracker: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,
      // outlook: twinTrackerOutlook,

      outlook: [
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: assetTagBleOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    twinTrackerPro: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTrackerThumbnail,

      mini1: twinTrackerThumbnail,
      mini2: twinTracker3,
      mini3: twinTracker4,
      mini4: twinTracker5,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      outlook: twinTrackerOutlook,
      download: [
        {
          name: 'Twin Tracker Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker Pro',
        },
      ],

      title: 'TwinTracker Pro',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },

    twinTrackerAoa: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twinTrackerAoa2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: aoaOutlook,
        },
      ],

      thumbnail: twinTrackerAoaThumb,

      mini1: twinTrackerAoa3,
      mini2: twinTrackerAoa1,
      mini3: twinTrackerAoa2,
      mini4: twinTrackerBracket,

      key1: twinTrackerAoa3,
      key2: twinTrackerAoa1,
      key3: twinTrackerAoa2,
      // outlook: twinTrackerOutlook,

      outlook: [
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
      ],
      title: 'TwinTracker AoA',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker AoA - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker AoA',
        },
      ],

      redDot: 0,
    },

    aoaStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaStarterKitThumb,

      mini1: aoaStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: aoaStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: aoaStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'AoA Starter Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },

    aoaEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaEnterpriseKitThumb,

      mini1: aoaEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: aoaEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'AoA Enterprise Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },
    bleStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleStarterKit2,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleStarterKit2,

      mini1: bleStarterKit2,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: bleStarterKit2,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: bleStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'BLE Starter Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },

    bleEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleEnterpriseKit,

      mini1: bleEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: bleEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'BLE Enterprise Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },
    twinTrackerUwb: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,
      topology: twintrackerUwbTopology,

      outlook: [
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
      ],
      title: 'TwinTracker UWB',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    uwbStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker UWB',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbStarterKitThumb,

      mini1: uwbStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: uwbStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: uwbStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'UWB Starter Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },

    uwbEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker UWB',
          desc: 'Tracks the wireless signals of asset tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag (BLE)',
          desc: 'Easily attaches to track worker locations via BLE.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbEnterpriseKitThumb,

      mini1: uwbEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: uwbEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      title: 'UWB Enterprise Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      redDot: 0,
    },

    comfortKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: comfortKit1,
          img2: uwbTag1,
          img3: uwbTag2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: comfortKitThumb,

      mini1: comfortKitThumb,
      mini2: comfortKit2,
      mini3: uwbTag1,
      mini4: uwbTag2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      title: 'Comfort Kit',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    gpsDevice: {
      design: [
        {
          title: '',
          desc: '',
          img1: vehicleTrackingKit1,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: vehicleTrackingKit2,
          img3: vehicleTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: vehicleTrackingKitThumb,

      mini1: vehicleTrackingKit1,
      mini2: enterpriseKit2,
      mini3: vehicleTrackingKit2,
      mini4: vehicleTrackingKit3,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'GPS Device',
          desc: 'OTR-GD4G2121',
          img: gpsOutlook,
        },
      ],
      title: 'GPS Device',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    gpsTag: {
      design: [
        {
          title: '',
          desc: '',
          img1: yardTrackingKitThumb,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: loraGateway1,
          img3: loraGateway2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: yardTrackingKit2,
          img3: yardTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: yardTrackingKitThumb,

      mini1: yardTrackingKitThumb,
      mini2: enterpriseKit2,
      mini3: loraGateway1,
      mini4: yardTrackingKit2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      title: 'GPS Tag',
      desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',

      download: [
        {
          name: 'Twin Tracker - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker',
        },
      ],

      redDot: 0,
    },

    cameraEnterpriseKit: {
      design: [
        {
          video: 'https://www.youtube.com/embed/Z5dC0EKcnuY?si=zeRLmNn-RZXXcjF0',
          videoEng: 'https://www.youtube.com/embed/ZQ8mwjm3lBg?si=Y_89mX4kMcO3wKyl',
          title: 'PTZ Camera',
          desc: 'Tracks vehicle locations in parking lots using an outdoor PTZ camera.',

          img1: enterpriseKit1,
          img2: '',
          img3: '',
        },
        {
          title: 'NVR',
          desc: 'Stores and streams camera image data.',

          img1: enterpriseKit2,
          img2: '',
          img3: '',
        },
        {
          title: 'Server PC',
          desc: 'Analyzes images and calculates positions.',

          img1: enterpriseKit3,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: enterpriseKit1,

      mini1: enterpriseKit1,
      mini2: enterpriseKit3,
      mini3: enterpriseKit2,
      mini4: '',

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      topology: enterpriseKitTopology,

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'PTZ Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'PTZ Camera',
        },
      ],

      title: 'Camera Enterprise Kit',
      desc: '',

      redDot: 0,
    },

    cameraStarterKit: {
      design: [
        {
          title: 'NVR',
          desc: 'Stores and streams camera image data.',

          img1: starterKit1,
          img2: '',
          img3: '',
        },
        {
          title: 'Server PC',
          desc: 'Analyzes images and calculates positions.',

          img1: '',
          img2: starterKit2,
          img3: starterKit3,
        },
        {
          title: 'Server PC',
          desc: 'Analyzes images and calculates positions.',

          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      mini1: starterKit1,
      mini2: starterKit2,
      mini3: starterKit4,
      mini4: starterKit5,

      key1: '',
      key2: '',
      key3: '',

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      topology: starterKitTopology,
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'Camera Starter Kit',
      desc: '',

      redDot: 0,
    },

    osServer: {
      design: [
        {
          img1: osServer1,
          img2: '',
          img3: '',
          img4: osServer2,
        },
      ],

      out: [],

      thumbnail: osServer1,

      mini1: osServer1,
      mini2: osServer2,
      mini3: osServer3,

      key1: '',
      key2: '',
      key3: '',

      topology: osServerTopology,

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'OS Server',
      desc: '',

      redDot: 0,
    },

    osRtls: {
      design: [
        {
          img1: edgeRtls1,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: edgeRtls1,

      mini1: edgeRtls1,
      mini2: starterKit3,
      mini3: starterKit8,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osRtlsTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'OS RTLS',
      desc: '',

      redDot: 0,
    },

    osAi: {
      design: [
        {
          img1: starterKit2,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      mini1: starterKit2,
      mini2: starterKit3,
      mini3: starterKit8,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osAiTopology,

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'OS AI',
      desc: '',

      redDot: 0,
    },

    osSwitch: {
      design: [
        {
          img1: starterKit4,
          img2: '',
          img3: '',
        },
        {
          img1: '',
          img2: starterKit5,
          img3: starterKit9,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: starterKit4,

      mini1: starterKit4,
      mini2: starterKit5,
      mini3: starterKit8,
      mini4: starterKit9,

      key1: '',
      key2: '',
      key3: '',

      topology: osSwitchTopology,

      outlook: [
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'NVR - Datasheet v1.0',
          date: '2023-11-20',
          data: 'NVR',
        },
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: 'OS Switch',
      desc: '',

      redDot: 0,
    },
    workerTracking: {
      design: [
        {
          title: 'Twin Tracker Pro',
          desc: 'Track the wireless signals of asset tag devices with a simple PoE (Power over Ethernet) connection without complicated installation.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag(UWB)',
          desc: 'Easily track the location of workers with a simple attachment.',
          img1: '',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Stores and calculates the location of assets.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],
      out: [
        {
          title: 'Twin Tracker Pro',
          desc: 'Track the wireless signals of asset tag devices with a simple PoE (Power over Ethernet) connection without complicated installation.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Tag(UWB)',
          desc: 'Easily track the location of workers with a simple attachment.',
          img: tagUwbOutlook,
        },
      ],
      thumbnail: workerTracking1,
      mini1: workerTracking1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,
      key1: workerTracking1,
      key2: tagUwb1,
      key3: twinTracker1,
      outlook: '',
      title: 'Twin Tracker Pro',
      desc: 'Track the wireless signals of asset tag devices with a simple PoE (Power over Ethernet) connection.',
    },

    // carTracking: {
    //   design: [
    //     {
    //       title: 'PTZ Camera',
    //       desc: 'Track the location of vehicles in the parking lot using PTZ outdoor cameras.',

    //       img1: carTrackingKey1,
    //       img2: carTrackingKey2,
    //       img3: carTrackingKey3,
    //     },

    //     {
    //       title: 'NVR',
    //       desc: 'Store and transmit camera image information.',

    //       img1: carTrackingKey4,
    //       img2: '',
    //       img3: '',
    //     },

    //     {
    //       title: 'Server PC',
    //       desc: 'Analyze images and calculate positions.',

    //       img1: carTrackingKey5,
    //       img2: '',
    //       img3: '',
    //     },
    //   ],

    //   out: [],

    //   thumbnail: carTracking1,

    //   //제품 아래 4가지 이미지
    //   mini1: carTracking1,
    //   mini2: carTracking2,
    //   mini3: carTracking3,
    //   mini4: carTracking4,

    //   key1: '',
    //   key2: '',
    //   key3: '',

    //   outlook: '',

    //   title: '',
    //   desc: '',

    //   redDot: 0,
    // },

    // peopleTracking: {
    //   design: [
    //     {
    //       title: 'IP Camera',
    //       desc: 'Track indoor pedestrian traffic using IP cameras.',

    //       img1: peopleTrackingKey1,
    //       img2: peopleTrackingKey2,
    //       img3: '',
    //     },

    //     {
    //       title: 'NVR',
    //       desc: 'Store and transmit camera image information.',

    //       img1: peopleTrackingKey3,
    //       img2: '',
    //       img3: '',
    //     },

    //     {
    //       title: 'Server PC',
    //       desc: 'Analyze images and calculate positions.',

    //       img1: peopleTrackingKey4,
    //       img2: '',
    //       img3: '',
    //     },
    //   ],

    //   out: [],

    //   thumbnail: peopleTracking1,

    //   //제품 아래 4가지 이미지
    //   mini1: peopleTracking1,
    //   mini2: peopleTracking2,
    //   mini3: peopleTracking3,
    //   mini4: peopleTracking4,

    //   key1: '',
    //   key2: '',
    //   key3: '',

    //   outlook: '',

    //   title: '',
    //   desc: '',

    //   redDot: 0,
    // },

    ptz: {
      design: [
        {
          title: 'PTZ Camera',
          desc: 'The PTZ outdoor camera tracks the location of a person or vehicle.',

          img1: ptzCamKey1,
          img2: ptzCamKey2,
          img3: ptzCamKey3,
        },
      ],

      out: [],

      thumbnail: ptzThumb,

      //제품 아래 4가지 이미지
      mini1: ptzCam1,
      mini2: ptzCam2,
      mini3: ptzCam3,
      mini4: ptzCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    ip: {
      design: [
        {
          title: 'IP Camera',
          desc: 'Track indoor floating population with IP camera.',

          img1: ipCamKey1,
          img2: ipCamKey2,
          img3: ipCamKey3,
        },
      ],

      out: [],

      thumbnail: ipThumb,

      //제품 아래 4가지 이미지
      mini1: ipCam1,
      mini2: ipCam2,
      mini3: ipCam3,
      mini4: ipCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    safetyBell: {
      thumbnail: safetyBellThumbnail,

      mini1: bell1,
      mini2: bell2,
      mini3: bell3,
      mini4: bell4,

      key1: bell1,
      key2: bell2,
      key3: bell3,

      outlook: bellOutlook,
    },

    smartSwitch: {
      thumbnail: switchThumbnail,

      mini1: switch1,
      mini2: switch2,
      mini3: switch3,
      mini4: switch4,

      key1: switch1,
      key2: switch2,
      key3: switch3,

      outlook: switchOutlook,
    },

    esl: {
      thumbnail: eslThumbnail,

      mini1: esl1,
      mini2: esl2,
      mini3: esl3,
      mini4: esl4,

      key1: esl1,
      key2: esl2,
      key3: esl3,

      outlook: eslOutlook,
    },

    mTag: {
      thumbnail: mTagThumb,

      mini1: mTag1,
      mini2: mTag2,
      mini3: mTag3,
      mini4: mTag4,

      key1: mTag1,
      key2: mTag2,
      key3: mTag3,

      outlook: mTagOutlook,
    },

    mCradle: {
      thumbnail: mCradleThumb,

      mini1: mCradle1,
      mini2: mCradle2,
      mini3: mCradle3,
      mini4: mCradle4,

      key1: mCradle5,
      key2: mCradle6,
      key3: mCradle7,

      outlook: mCradleOutlook,
    },

    robotBasic: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Delivers items by integrating with the ORBRO system.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag (UWB)',
          desc: 'Easily attaches to track worker locations.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Stores and computes asset locations.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: deliverRobot1,

      // Four preview images
      mini1: deliverRobot1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    delivery: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Delivers items by integrating with the ORBRO system.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Loading Kiosk',
          desc: 'Automatically loads items onto the robot when packages are placed on the device and the robot is called.',
          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },
        {
          title: 'Cobot',
          desc: 'Unloads items from the delivery robot when it arrives.',
          img2: cobot3,
          img3: cobot2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag (UWB)',
          desc: 'Easily attaches to track worker locations.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Stores and computes asset locations.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: deliverPackage,

      // Four preview images
      mini1: deliverPackage,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: workerTracking1,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    disinfection: {
      design: [
        {
          title: 'Delivery Robot',
          desc: 'Delivers items by integrating with the ORBRO system.',
          img2: deliverRobot1,
          img3: deliverRobot2,
        },
        {
          title: 'Loading Kiosk',
          desc: 'Automatically loads items onto the robot when packages are placed on the device and the robot is called.',
          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },
        {
          title: 'Cobot',
          desc: 'Unloads items from the delivery robot when it arrives.',
          img2: cobot3,
          img3: cobot2,
        },
        {
          title: 'Disinfection Device Kit',
          desc: 'Device that safely disinfects items during the loading and unloading process with the delivery robot.',
          img1: disinfection2,
        },
        {
          title: 'Twin Tracker Pro',
          desc: 'Tracks the wireless signals of tag devices using only a PoE (Power over Ethernet) connection without complex installation processes.',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
        {
          title: 'Tag (UWB)',
          desc: 'Easily attaches to track worker locations.',
          img2: tagUwb1,
          img3: tagUwb2,
        },
        {
          title: 'Server PC',
          desc: 'Stores and computes asset locations.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: disinfection1,

      // Four preview images
      mini1: disinfection1,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: disinfection2,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },
  },
};
